export default __webpack_public_path__ + "static/inner-belief_small-image_3-45016b3e04dbcd211d352df821d752e0.webp";